// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=\"%23333\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 10l5 5 5-5z\"/><path d=\"M0 0h24v24H0z\" fill=\"none\"/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/png;base64,...", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg width=%2710%27 height=%276%27 viewBox=%270 0 10 6%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 1L5 5L9 1%27 stroke=%27%23404040%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Profile_MainContainer__JSkc0 {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: clamp(20px, 5vw, 50px);
  box-sizing: border-box;
  min-height: 100vh;
  background: linear-gradient(to bottom right, #fff5f5, #fff);
}

.Profile_MainWrapper__Cbv2X {
  border: 1px solid #ffaeae;
  border-radius: 20px;
  background-color: #fff;
  box-shadow: 0 10px 25px rgba(129, 126, 126, 0.1);
  width: 90%;
  max-width: 800px;
  height: 100%;
  margin: 0 auto;
  transition: all 0.3s ease;
}

.Profile_topDiv__aMsi1 {
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #e4e4e4;
  padding: 12px;
}

.Profile_topText__cv3SY {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  color: #363636;
  margin-top: 5px;
}

.Profile_topClockDiv__RFvm6 {
  display: flex;
  gap: 5px;
  margin-top: 7px;
}

.Profile_clockIcon__XzJ6d {
  height: 20px;
  width: 20px;
  align-self: center;
}

.Profile_clockText__isfp1 {
  font-size: 14px;
  color: #817e7e;
}

.Profile_PageText__O5\\+g0 {
  font-family: "CircularXXWeb-Medium";
  font-size: 16px;
  color: #040404cc;
  text-align: center;
}

.Profile_shieldDiv__9NdUX {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  justify-content: center;
  margin-top: 50px;
}

.Profile_shieldText__QskPM {
  font-size: 14px;
  color: #404040bf;
  margin-left: 5px;
}

.Profile_Line__x5ynZ {
  border-bottom: 1px solid #e4e4e4;
  margin-top: 50px;
}

.Profile_verifyButton__AOYs4 {
  background-image: linear-gradient(45deg, #f73439, #f8777b) !important;
  font-size: clamp(14px, 1.2vw, 16px);
  font-weight: 500;
  color: #fff;
  border-radius: 12px !important;
  border: none;
  cursor: pointer;
  padding: 12px 40px;
  margin: 20px auto;
  margin-left: 50%;
  transform: translate(-50%);
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(247, 52, 57, 0.2);
}

.Profile_verifyButton__AOYs4:hover {
  transform: translate(-50%, -2px);
  box-shadow: 0 6px 20px rgba(247, 52, 57, 0.3);
}

.Profile_FormContainer__LX6Di {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  padding: clamp(15px, 3vw, 30px);
  box-sizing: border-box;
}

.Profile_FormText__8b7ym {
  font-family: "CircularXXWeb-Medium";
  font-size: 16px;
  color: #040404cc;
  font-weight: 500;
  margin: 10px 0;
  display: flex;
  align-items: center;
  gap: 4px;
}

.Profile_mandatoryAsterisk__5OfYd {
  color: #f73439;
  font-size: 16px;
}

.Profile_errorText__AYOYa {
  color: #f73439;
  font-size: 12px;
  margin-top: 4px;
  padding: 8px 0;
  margin-bottom: 8px;
}

.Profile_inputLabelGroup__exFuW {
  border: 1px solid transparent;
  padding: 8px;
  border-radius: 4px;
  margin-bottom: 8px;
}

.Profile_inputLabelGroup__exFuW.Profile_hasError__-adn2 {
  border-color: #f73439;
}

.Profile_inputError__5x0Sn {
  border-color: #f73439 !important;
}

.Profile_inputError__5x0Sn:focus {
  border-color: #f73439 !important;
  box-shadow: 0 0 0 3px rgba(247, 52, 57, 0.1) !important;
}

/* Removed duplicate dropdown styles */

.Profile_nomineeSection__vtMkL {
  margin-bottom: 30px;
}

.Profile_nomineeHeader__NS5NL {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.Profile_nomineeCard__c3rjw {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 20px;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.Profile_nomineeCardHeader__f0hwe {
  background-color: #f5f5f5;
  padding: 12px 15px;
  border-bottom: 1px solid #ddd;
}

.Profile_nomineeCardHeader__f0hwe h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.Profile_nomineeCardBody__jpchL {
  padding: 15px;
}

.Profile_nomineeRow__Hq85e {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
  flex-wrap: wrap;
}

.Profile_nomineeField__gdulK {
  flex: 1 1;
  min-width: 200px;
}

.Profile_nomineeField__gdulK label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  color: #555;
  font-weight: 500;
}

.Profile_nomineeInput__fzQWq,
.Profile_nomineeSelect__0ScyW {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}

.Profile_nomineeSelect__0ScyW {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 20px;
}

.Profile_dobGroup__C\\+9CE {
  display: flex;
  gap: 8px;
  width: 100%;
}

.Profile_dobInput__U93fJ {
  flex: 1 1;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
  width: 100%;
  max-width: 80px;
}

.Profile_shareField__24d4t {
  display: flex;
  align-items: center;
  gap: 10px;
}

.Profile_shareSlider__c4\\+W- {
  flex: 1 1;
  -webkit-appearance: none;
  height: 6px;
  border-radius: 3px;
  background: #ddd;
  outline: none;
}

.Profile_shareSlider__c4\\+W-::-webkit-slider-thumb {
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #f75054;
  cursor: pointer;
}

.Profile_shareSlider__c4\\+W-::-moz-range-thumb {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #f75054;
  cursor: pointer;
}

.Profile_shareValue__kbhC3 {
  min-width: 40px;
  text-align: center;
  font-weight: bold;
  color: #f75054;
  font-size: 14px;
}

.Profile_guardianSection__DURrt {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 16px;
  border: 2px solid #ffd966;
  border-radius: 8px;
  background: linear-gradient(135deg, #fffdf5 0%, #fff7db 100%);

  animation: Profile_slideDown__T63DL 0.3s ease-in-out;
}

@keyframes Profile_slideDown__T63DL {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.Profile_guardianSectionTitle__AkQy8 {
  margin: 0 0 15px 0;
  font-size: 16px;
  font-weight: 600;
  color: #f73439;
  display: flex;
  align-items: center;
  gap: 6px;
}

.Profile_guardianSectionTitle__AkQy8::before {
  content: "👤";
  font-size: 18px;
}

/* Nominee Tabs Styles */
.Profile_nomineeTabs__ivFdj {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
  border-bottom: 2px solid #f0f0f0;
  overflow-x: auto;
  padding: 0 0 8px 0;
}

.Profile_nomineeTab__IMnrs {
  padding: 10px 20px;
  border: none;
  background-color: transparent;
  color: #666;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
  white-space: nowrap;
  position: relative;
}

.Profile_nomineeTab__IMnrs:hover {
  color: #f73439;
  background-color: #f9f9f9;
  border-radius: 6px 6px 0 0;
}

.Profile_nomineeTab__IMnrs.Profile_active__2PlmE {
  color: #f73439;
  border-bottom: 3px solid #f73439;
}

.Profile_nomineeTabContent__qUIP4 {
  animation: Profile_fadeIn__hipNC 0.3s ease-in-out;
}

@keyframes Profile_fadeIn__hipNC {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .Profile_nomineeRow__Hq85e {
    flex-direction: column;
    gap: 10px;
  }

  .Profile_nomineeField__gdulK {
    width: 100% !important;
  }

  .Profile_nomineeHeader__NS5NL {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .Profile_nomineeHeader__NS5NL .Profile_customDropdown__FB-31 {
    width: 100%;
  }

  .Profile_nomineeHeader__NS5NL .Profile_FormText__8b7ym {
    text-align: left;
  }

  .Profile_dobGroup__C\\+9CE {
    width: 100%;
  }

  .Profile_dobInput__U93fJ {
    max-width: none;
  }
}

.Profile_mandatorySection__2NPK2 {
  margin-top: 30px;
  margin-bottom: 20px;
}

.Profile_MandatoryHeading__kJrKR {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
}

.Profile_mandatoryCard__ewU1P {
  border: 1px solid #ffaeae;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.Profile_MandatoryContainer__4BBZ9 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  border-bottom: 1px solid #ffaeae;
}

.Profile_MandatoryContainer__4BBZ9:last-child {
  border-bottom: none;
}

.Profile_MandatoryText__b8TvX {
  font-size: 14px;
  color: #040404cc;
  font-family: "CircularXXWeb-Medium";
}

.Profile_MandatoryTick__\\+LvUh {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #f73439;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.Profile_MandatoryTick__\\+LvUh::after {
  content: "";
  width: 6px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  margin-bottom: 2px;
}

.Profile_nomineeCount__5GF-n {
  margin: 20px 0;
}

.Profile_nomineeCount__5GF-n select {
  width: 100px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-left: 10px;
}

.Profile_nomineeDetails__\\+zHbn {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 12px;
  margin: 20px 0;
  border: 1px solid #e0e0e0;
}

.Profile_nomineeDetails__\\+zHbn h3 {
  color: #333;
  margin-bottom: 20px;
  font-size: 18px;
}

.Profile_nomineeDetails__\\+zHbn input,
.Profile_nomineeDetails__\\+zHbn select {
  width: 100%;
  /* padding: 10px; */
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  margin: 5px 0;
  transition: border-color 0.2s;
}

.Profile_nomineeDetails__\\+zHbn input:focus,
.Profile_nomineeDetails__\\+zHbn select:focus {
  border-color: #f73439;
  outline: none;
}

.Profile_guardianDetails__UJo9W {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  margin-top: 20px;
  border: 1px solid #e0e0e0;
}

.Profile_guardianDetails__UJo9W h4 {
  color: #333;
  margin-bottom: 15px;
  font-size: 16px;
}

.Profile_rowFields__YTTVl {
  display: flex;
  gap: 20px;
  margin-bottom: 15px;
}

.Profile_fieldColumn__tOYob {
  flex: 1 1;
}

.Profile_shareContainer__n478q {
  margin: 20px 0;
}

.Profile_sliderContainer__Eb2qX {
  position: relative;
  padding: 10px 0;
}

.Profile_slider__boyi2 {
  -webkit-appearance: none;
  width: calc(100% - 20px);
  height: 8px;
  border-radius: 5px;
  background: #ddd;
  outline: none;
  margin: 10px;
  padding: 6px 0;
}

.Profile_slider__boyi2::-webkit-slider-thumb {
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #f73439;
  cursor: pointer;
  -webkit-transition: background 0.15s ease-in-out;
  transition: background 0.15s ease-in-out;
  border: 2px solid white;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
}

.Profile_slider__boyi2::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border: 2px solid white;
  border-radius: 50%;
  background: #f73439;
  cursor: pointer;
  -moz-transition: background 0.15s ease-in-out;
  transition: background 0.15s ease-in-out;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
}

.Profile_sliderValue__g0pxB {
  position: absolute;
  right: 10px;
  top: -25px;
  font-size: 14px;
  color: #333;
  font-weight: 500;
  width: 40px;
  text-align: right;
}

.Profile_dobContainer__BVeDT {
  margin: 15px 0;
}

.Profile_dobInputs__8Tmw7 {
  display: flex;
  gap: 10px;
}

.Profile_dobInputs__8Tmw7 input {
  width: 60px;
  /* padding: 8px; */
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: center;
}

.Profile_dobInputs__8Tmw7 input:last-child {
  width: 80px;
}

.Profile_nomineeDetails__\\+zHbn {
  margin: 20px 0;
  padding: clamp(15px, 3vw, 25px);
  border: 1px solid #ffaeae;
  border-radius: 16px;
  background-color: #fff;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.Profile_nomineeDetails__\\+zHbn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
}

.Profile_nomineeDetails__\\+zHbn label {
  font-size: 16px;
  color: #333;
  margin-bottom: 5px;
  display: block;
}

.Profile_nomineeDetails__\\+zHbn input[type="text"],
.Profile_nomineeDetails__\\+zHbn input[type="number"],
.Profile_nomineeDetails__\\+zHbn select {
  width: 100%;
  padding: 10px;
  margin: 5px 0 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
}

.Profile_nomineeDetails__\\+zHbn select {
  appearance: none; /* Remove default arrow */
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right; /* Add a dropdown arrow icon here */
  background-size: 12px;
}

.Profile_nomineeDetailsInput__IWWop {
  padding: 12px 16px;
  border: 1px solid #d3d3d3;
  border-radius: 8px;
  font-size: 14px;
  height: 42px;
  box-sizing: border-box;
  transition: all 0.2s ease;
  background-color: #fafafa;
}

.Profile_nomineeDetailsInput__IWWop:focus {
  outline: none;
  border-color: #f73439;
}

.Profile_nomineeDetailsInput__IWWop::placeholder {
  color: #757575;
}

.Profile_nomineeDetailsInput__IWWop:focus {
  border-color: #f73439;
  outline: none;
  box-shadow: 0 0 0 3px rgba(247, 52, 57, 0.1);
  background-color: #fff;
}

.Profile_networthFields__6yf4N {
  display: flex;
  gap: 15px;
  margin-top: 10px;
  align-items: center;
  flex-wrap: wrap;
}

.Profile_networthFields__6yf4N > input:first-child {
  flex: 1 1;
  min-width: 150px;
}

.Profile_dateFields__-Soti {
  display: flex;
  gap: 10px;
  flex: 1 1;
}

.Profile_dateFields__-Soti input {
  width: 100%;
  text-align: center;
  min-width: 80px;
}

.Profile_motherNameSection__O48qt {
  margin-top: 10px;
}

.Profile_motherNameFields__hVGBB {
  display: flex;
  gap: 15px;
  margin-top: 10px;
}

.Profile_motherNameFields__hVGBB input {
  flex: 1 1;
}

.Profile_dropdownSection__if3uk {
  margin: 15px 0;
}

.Profile_dropdownRow__Vof0c {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.Profile_dropdownRow__Vof0c .Profile_FormText__8b7ym {
  margin: 0;
  flex: 1 1;
}

.Profile_customDropdown__FB-31 {
  width: 200px;
  padding: 8px 35px 8px 15px;
  border: 1px solid #d3d3d3;
  border-radius: 5px;
  background-color: #f9f9f9;
  font-size: 14px;
  color: #404040bf;
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: right 15px center;
}

.Profile_customDropdown__FB-31:focus {
  outline: none;
  border-color: #f73439;
}

.Profile_customDropdown__FB-31 option {
  padding: 8px;
}

.Profile_modal__sSw3A {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.Profile_modalHeader__BBK-z {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
}

.Profile_modalHeader__BBK-z h2 {
  margin: 0;
  font-size: 20px;
  color: #333;
}

.Profile_closeButton__uH0wh {
  position: absolute;
  right: -15px;
  top: -15px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #f73439;
  color: white;
  border: none;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  line-height: 1;
  transition: background-color 0.2s;
}

.Profile_closeButton__uH0wh:hover {
  background: #f8777b;
}

.Profile_saveButton__5-LHJ {
  background: #f73439 !important;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 20px;
  transition: background-color 0.2s;
}

.Profile_saveButton__5-LHJ:hover {
  background: #f8777b !important;
}

.Profile_modalContent__wmjZ1 {
  background: white;
  padding: 30px;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  position: relative;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.Profile_modalContent__wmjZ1 h2 {
  margin: 0 0 15px 0;
  color: #333;
}

.Profile_modalContent__wmjZ1 p {
  margin-bottom: 20px;
  color: #666;
}

.Profile_modalContent__wmjZ1 button {
  background: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 15px;
}

.Profile_modalContent__wmjZ1 button:hover {
  background: #0056b3;
}

.Profile_modalContent__wmjZ1 input,
.Profile_modalContent__wmjZ1 select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: 5px 0 15px 0;
}

.Profile_modalContent__wmjZ1 label {
  display: block;
  margin-bottom: 5px;
  color: #555;
  font-weight: 500;
}

.Profile_networthSection__HbA0L {
  margin-top: 20px;
}

.Profile_hideNumberSpinner__-NFpw {
  /* Hide number input spinners for Webkit browsers */
  -webkit-appearance: none;
  margin: 0;
}

.Profile_hideNumberSpinner__-NFpw::-webkit-inner-spin-button,
.Profile_hideNumberSpinner__-NFpw::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Hide number input spinners for Firefox */
.Profile_hideNumberSpinner__-NFpw[type="number"] {
  -moz-appearance: textfield;
}

@media screen and (max-width: 1024px) {
  .Profile_MainWrapper__Cbv2X {
    width: 95%;
  }

  .Profile_FormContainer__LX6Di {
    width: 95%;
  }

  .Profile_topText__cv3SY {
    font-size: 18px;
  }
}

@media screen and (max-width: 850px) {
  .Profile_motherNameFields__hVGBB {
    width: 100%;
    box-sizing: border-box;
  }
}

@media screen and (max-width: 768px) {
  .Profile_MainContainer__JSkc0 {
    padding: 15px;
  }

  .Profile_topText__cv3SY {
    font-size: 16px;
  }

  .Profile_clockText__isfp1 {
    font-size: 12px;
  }

  .Profile_parentRow__Hg3Kf {
    flex-direction: column;
  }

  .Profile_parentField__bQRTN {
    width: 100%;
  }

  .Profile_motherNameFields__hVGBB {
    flex-direction: column;
    gap: 15px;
    width: 100%;
    box-sizing: border-box;
    padding: 0;
    margin: 10px 0;
  }

  .Profile_motherNameFields__hVGBB input {
    width: 100%;
    box-sizing: border-box;
  }

  .Profile_nomineeDetails__\\+zHbn {
    padding: 15px;
  }

  .Profile_rowFields__YTTVl {
    flex-direction: column;
    gap: 15px;
  }

  .Profile_dobInputs__8Tmw7 {
    justify-content: space-between;
  }

  .Profile_dobInputs__8Tmw7 input {
    width: 28%;
  }

  .Profile_networthFields__6yf4N {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .Profile_networthFields__6yf4N > input:first-child {
    width: 100% !important;
    flex: none;
  }

  .Profile_dateFields__-Soti {
    width: 100%;
    display: flex;
    gap: 10px;
  }

  .Profile_dateFields__-Soti input,
  .Profile_dateFields__-Soti .Profile_nomineeDetailsInput__IWWop {
    width: auto !important;
    flex: 1 1;
    min-width: 0;
  }

  .Profile_dropdownRow__Vof0c {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }

  .Profile_customDropdown__FB-31 {
    width: 100%;
  }
}

@media screen and (max-width: 480px) {
  .Profile_MainContainer__JSkc0 {
    padding: 10px;
  }

  .Profile_MainWrapper__Cbv2X {
    width: 100%;
    border-radius: 12px;
  }

  .Profile_FormContainer__LX6Di {
    width: 100%;
    padding: 10px;
  }

  .Profile_verifyButton__AOYs4 {
    width: 90%;
    padding: 10px 20px;
  }

  .Profile_nomineeDetailsInput__IWWop {
    height: 38px;
    padding: 8px 12px;
  }
}

.Profile_dobLabel__xLGti {
  display: flex;
  align-items: center;
  gap: 8px;
}

.Profile_minorBadge__vr25m {
  font-size: 10px;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 999px;
  background: #fff4e5;
  color: #b45309;
  border: 1px solid #facc15;
  white-space: nowrap;
  margin-left: 5px;
}

.Profile_addressLabel__Ezxb8 {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.Profile_addressMeta__8PQd1 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  border-radius: 999px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.Profile_addressCheckbox__5aCDX {
  width: 12px;
  height: 12px;
  /* cursor: not-allowed; */
}

.Profile_addressCheckboxText__K0ARR {
  font-size: 11px;
  color: #475569;
  white-space: nowrap;
}

.Profile_parentRow__Hg3Kf {
  display: flex;
  gap: 16px;
}

.Profile_parentField__bQRTN {
  flex: 1 1;
}

.Profile_parentField__bQRTN input {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/organism/Profile.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,+BAA+B;EAC/B,sBAAsB;EACtB,iBAAiB;EACjB,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,gDAAgD;EAChD,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,qEAAqE;EACrE,mCAAmC;EACnC,gBAAgB;EAChB,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,uDAAuD;AACzD;;AAEA,sCAAsC;;AAEtC;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yDAAuN;EACvN,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,6DAA6D;;EAE7D,oDAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,iDAAkC;AACpC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gDAAwC;EAAxC,wCAAwC;EACxC,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,6CAAwC;EAAxC,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,0CAA0C;EAC1C;;wBAEsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB,EAAE,yBAAyB;EAC3C,mEAA4D,EAAE,mCAAmC;EACjG,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAO;AACT;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yDAAwQ;EACxQ,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mDAAmD;EACnD,wBAAwB;EACxB,SAAS;AACX;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,2CAA2C;AAC3C;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,sBAAsB;IACtB,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,aAAa;IACb,SAAS;EACX;;EAEA;;IAEE,sBAAsB;IACtB,SAAO;IACP,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;AACb","sourcesContent":[".MainContainer {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  padding: clamp(20px, 5vw, 50px);\n  box-sizing: border-box;\n  min-height: 100vh;\n  background: linear-gradient(to bottom right, #fff5f5, #fff);\n}\n\n.MainWrapper {\n  border: 1px solid #ffaeae;\n  border-radius: 20px;\n  background-color: #fff;\n  box-shadow: 0 10px 25px rgba(129, 126, 126, 0.1);\n  width: 90%;\n  max-width: 800px;\n  height: 100%;\n  margin: 0 auto;\n  transition: all 0.3s ease;\n}\n\n.topDiv {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  border-bottom: 1px solid #e4e4e4;\n  padding: 12px;\n}\n\n.topText {\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 28px;\n  color: #363636;\n  margin-top: 5px;\n}\n\n.topClockDiv {\n  display: flex;\n  gap: 5px;\n  margin-top: 7px;\n}\n\n.clockIcon {\n  height: 20px;\n  width: 20px;\n  align-self: center;\n}\n\n.clockText {\n  font-size: 14px;\n  color: #817e7e;\n}\n\n.PageText {\n  font-family: \"CircularXXWeb-Medium\";\n  font-size: 16px;\n  color: #040404cc;\n  text-align: center;\n}\n\n.shieldDiv {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin: 0 auto;\n  justify-content: center;\n  margin-top: 50px;\n}\n\n.shieldText {\n  font-size: 14px;\n  color: #404040bf;\n  margin-left: 5px;\n}\n\n.Line {\n  border-bottom: 1px solid #e4e4e4;\n  margin-top: 50px;\n}\n\n.verifyButton {\n  background-image: linear-gradient(45deg, #f73439, #f8777b) !important;\n  font-size: clamp(14px, 1.2vw, 16px);\n  font-weight: 500;\n  color: #fff;\n  border-radius: 12px !important;\n  border: none;\n  cursor: pointer;\n  padding: 12px 40px;\n  margin: 20px auto;\n  margin-left: 50%;\n  transform: translate(-50%);\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(247, 52, 57, 0.2);\n}\n\n.verifyButton:hover {\n  transform: translate(-50%, -2px);\n  box-shadow: 0 6px 20px rgba(247, 52, 57, 0.3);\n}\n\n.FormContainer {\n  width: 90%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: clamp(15px, 3vw, 30px);\n  box-sizing: border-box;\n}\n\n.FormText {\n  font-family: \"CircularXXWeb-Medium\";\n  font-size: 16px;\n  color: #040404cc;\n  font-weight: 500;\n  margin: 10px 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.mandatoryAsterisk {\n  color: #f73439;\n  font-size: 16px;\n}\n\n.errorText {\n  color: #f73439;\n  font-size: 12px;\n  margin-top: 4px;\n  padding: 8px 0;\n  margin-bottom: 8px;\n}\n\n.inputLabelGroup {\n  border: 1px solid transparent;\n  padding: 8px;\n  border-radius: 4px;\n  margin-bottom: 8px;\n}\n\n.inputLabelGroup.hasError {\n  border-color: #f73439;\n}\n\n.inputError {\n  border-color: #f73439 !important;\n}\n\n.inputError:focus {\n  border-color: #f73439 !important;\n  box-shadow: 0 0 0 3px rgba(247, 52, 57, 0.1) !important;\n}\n\n/* Removed duplicate dropdown styles */\n\n.nomineeSection {\n  margin-bottom: 30px;\n}\n\n.nomineeHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.nomineeCard {\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  background-color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n}\n\n.nomineeCardHeader {\n  background-color: #f5f5f5;\n  padding: 12px 15px;\n  border-bottom: 1px solid #ddd;\n}\n\n.nomineeCardHeader h3 {\n  margin: 0;\n  font-size: 16px;\n  color: #333;\n}\n\n.nomineeCardBody {\n  padding: 15px;\n}\n\n.nomineeRow {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 15px;\n  flex-wrap: wrap;\n}\n\n.nomineeField {\n  flex: 1;\n  min-width: 200px;\n}\n\n.nomineeField label {\n  display: block;\n  margin-bottom: 5px;\n  font-size: 14px;\n  color: #555;\n  font-weight: 500;\n}\n\n.nomineeInput,\n.nomineeSelect {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.nomineeSelect {\n  appearance: none;\n  background-image: url('data:image/svg+xml;utf8,<svg fill=\"%23333\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 10l5 5 5-5z\"/><path d=\"M0 0h24v24H0z\" fill=\"none\"/></svg>');\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  background-size: 20px;\n}\n\n.dobGroup {\n  display: flex;\n  gap: 8px;\n  width: 100%;\n}\n\n.dobInput {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n  text-align: center;\n  width: 100%;\n  max-width: 80px;\n}\n\n.shareField {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.shareSlider {\n  flex: 1;\n  -webkit-appearance: none;\n  height: 6px;\n  border-radius: 3px;\n  background: #ddd;\n  outline: none;\n}\n\n.shareSlider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #f75054;\n  cursor: pointer;\n}\n\n.shareSlider::-moz-range-thumb {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #f75054;\n  cursor: pointer;\n}\n\n.shareValue {\n  min-width: 40px;\n  text-align: center;\n  font-weight: bold;\n  color: #f75054;\n  font-size: 14px;\n}\n\n.guardianSection {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  padding: 16px;\n  border: 2px solid #ffd966;\n  border-radius: 8px;\n  background: linear-gradient(135deg, #fffdf5 0%, #fff7db 100%);\n\n  animation: slideDown 0.3s ease-in-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.guardianSectionTitle {\n  margin: 0 0 15px 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #f73439;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.guardianSectionTitle::before {\n  content: \"👤\";\n  font-size: 18px;\n}\n\n/* Nominee Tabs Styles */\n.nomineeTabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 20px;\n  border-bottom: 2px solid #f0f0f0;\n  overflow-x: auto;\n  padding: 0 0 8px 0;\n}\n\n.nomineeTab {\n  padding: 10px 20px;\n  border: none;\n  background-color: transparent;\n  color: #666;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  border-bottom: 3px solid transparent;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  position: relative;\n}\n\n.nomineeTab:hover {\n  color: #f73439;\n  background-color: #f9f9f9;\n  border-radius: 6px 6px 0 0;\n}\n\n.nomineeTab.active {\n  color: #f73439;\n  border-bottom: 3px solid #f73439;\n}\n\n.nomineeTabContent {\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@media (max-width: 768px) {\n  .nomineeRow {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .nomineeField {\n    width: 100% !important;\n  }\n\n  .nomineeHeader {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .nomineeHeader .customDropdown {\n    width: 100%;\n  }\n\n  .nomineeHeader .FormText {\n    text-align: left;\n  }\n\n  .dobGroup {\n    width: 100%;\n  }\n\n  .dobInput {\n    max-width: none;\n  }\n}\n\n.mandatorySection {\n  margin-top: 30px;\n  margin-bottom: 20px;\n}\n\n.MandatoryHeading {\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 15px;\n}\n\n.mandatoryCard {\n  border: 1px solid #ffaeae;\n  border-radius: 8px;\n  background-color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n}\n\n.MandatoryContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 15px;\n  border-bottom: 1px solid #ffaeae;\n}\n\n.MandatoryContainer:last-child {\n  border-bottom: none;\n}\n\n.MandatoryText {\n  font-size: 14px;\n  color: #040404cc;\n  font-family: \"CircularXXWeb-Medium\";\n}\n\n.MandatoryTick {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: #f73439;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.MandatoryTick::after {\n  content: \"\";\n  width: 6px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n  margin-bottom: 2px;\n}\n\n.nomineeCount {\n  margin: 20px 0;\n}\n\n.nomineeCount select {\n  width: 100px;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin-left: 10px;\n}\n\n.nomineeDetails {\n  background: #f8f9fa;\n  padding: 25px;\n  border-radius: 12px;\n  margin: 20px 0;\n  border: 1px solid #e0e0e0;\n}\n\n.nomineeDetails h3 {\n  color: #333;\n  margin-bottom: 20px;\n  font-size: 18px;\n}\n\n.nomineeDetails input,\n.nomineeDetails select {\n  width: 100%;\n  /* padding: 10px; */\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  margin: 5px 0;\n  transition: border-color 0.2s;\n}\n\n.nomineeDetails input:focus,\n.nomineeDetails select:focus {\n  border-color: #f73439;\n  outline: none;\n}\n\n.guardianDetails {\n  background: #fff;\n  padding: 20px;\n  border-radius: 8px;\n  margin-top: 20px;\n  border: 1px solid #e0e0e0;\n}\n\n.guardianDetails h4 {\n  color: #333;\n  margin-bottom: 15px;\n  font-size: 16px;\n}\n\n.rowFields {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 15px;\n}\n\n.fieldColumn {\n  flex: 1;\n}\n\n.shareContainer {\n  margin: 20px 0;\n}\n\n.sliderContainer {\n  position: relative;\n  padding: 10px 0;\n}\n\n.slider {\n  -webkit-appearance: none;\n  width: calc(100% - 20px);\n  height: 8px;\n  border-radius: 5px;\n  background: #ddd;\n  outline: none;\n  margin: 10px;\n  padding: 6px 0;\n}\n\n.slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #f73439;\n  cursor: pointer;\n  transition: background 0.15s ease-in-out;\n  border: 2px solid white;\n  box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);\n}\n\n.slider::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  border: 2px solid white;\n  border-radius: 50%;\n  background: #f73439;\n  cursor: pointer;\n  transition: background 0.15s ease-in-out;\n  box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);\n}\n\n.sliderValue {\n  position: absolute;\n  right: 10px;\n  top: -25px;\n  font-size: 14px;\n  color: #333;\n  font-weight: 500;\n  width: 40px;\n  text-align: right;\n}\n\n.dobContainer {\n  margin: 15px 0;\n}\n\n.dobInputs {\n  display: flex;\n  gap: 10px;\n}\n\n.dobInputs input {\n  width: 60px;\n  /* padding: 8px; */\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  text-align: center;\n}\n\n.dobInputs input:last-child {\n  width: 80px;\n}\n\n.nomineeDetails {\n  margin: 20px 0;\n  padding: clamp(15px, 3vw, 25px);\n  border: 1px solid #ffaeae;\n  border-radius: 16px;\n  background-color: #fff;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);\n  transition:\n    transform 0.2s ease,\n    box-shadow 0.2s ease;\n}\n\n.nomineeDetails:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);\n}\n\n.nomineeDetails label {\n  font-size: 16px;\n  color: #333;\n  margin-bottom: 5px;\n  display: block;\n}\n\n.nomineeDetails input[type=\"text\"],\n.nomineeDetails input[type=\"number\"],\n.nomineeDetails select {\n  width: 100%;\n  padding: 10px;\n  margin: 5px 0 15px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 14px;\n}\n\n.nomineeDetails select {\n  appearance: none; /* Remove default arrow */\n  background: url(\"data:image/png;base64,...\") no-repeat right; /* Add a dropdown arrow icon here */\n  background-size: 12px;\n}\n\n.nomineeDetailsInput {\n  padding: 12px 16px;\n  border: 1px solid #d3d3d3;\n  border-radius: 8px;\n  font-size: 14px;\n  height: 42px;\n  box-sizing: border-box;\n  transition: all 0.2s ease;\n  background-color: #fafafa;\n}\n\n.nomineeDetailsInput:focus {\n  outline: none;\n  border-color: #f73439;\n}\n\n.nomineeDetailsInput::placeholder {\n  color: #757575;\n}\n\n.nomineeDetailsInput:focus {\n  border-color: #f73439;\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(247, 52, 57, 0.1);\n  background-color: #fff;\n}\n\n.networthFields {\n  display: flex;\n  gap: 15px;\n  margin-top: 10px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.networthFields > input:first-child {\n  flex: 1;\n  min-width: 150px;\n}\n\n.dateFields {\n  display: flex;\n  gap: 10px;\n  flex: 1;\n}\n\n.dateFields input {\n  width: 100%;\n  text-align: center;\n  min-width: 80px;\n}\n\n.motherNameSection {\n  margin-top: 10px;\n}\n\n.motherNameFields {\n  display: flex;\n  gap: 15px;\n  margin-top: 10px;\n}\n\n.motherNameFields input {\n  flex: 1;\n}\n\n.dropdownSection {\n  margin: 15px 0;\n}\n\n.dropdownRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n}\n\n.dropdownRow .FormText {\n  margin: 0;\n  flex: 1;\n}\n\n.customDropdown {\n  width: 200px;\n  padding: 8px 35px 8px 15px;\n  border: 1px solid #d3d3d3;\n  border-radius: 5px;\n  background-color: #f9f9f9;\n  font-size: 14px;\n  color: #404040bf;\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%23404040' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 15px center;\n}\n\n.customDropdown:focus {\n  outline: none;\n  border-color: #f73439;\n}\n\n.customDropdown option {\n  padding: 8px;\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  position: relative;\n}\n\n.modalHeader h2 {\n  margin: 0;\n  font-size: 20px;\n  color: #333;\n}\n\n.closeButton {\n  position: absolute;\n  right: -15px;\n  top: -15px;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background: #f73439;\n  color: white;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  line-height: 1;\n  transition: background-color 0.2s;\n}\n\n.closeButton:hover {\n  background: #f8777b;\n}\n\n.saveButton {\n  background: #f73439 !important;\n  color: white;\n  border: none;\n  padding: 12px 30px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  margin-top: 20px;\n  transition: background-color 0.2s;\n}\n\n.saveButton:hover {\n  background: #f8777b !important;\n}\n\n.modalContent {\n  background: white;\n  padding: 30px;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 500px;\n  position: relative;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n}\n\n.modalContent h2 {\n  margin: 0 0 15px 0;\n  color: #333;\n}\n\n.modalContent p {\n  margin-bottom: 20px;\n  color: #666;\n}\n\n.modalContent button {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 15px;\n}\n\n.modalContent button:hover {\n  background: #0056b3;\n}\n\n.modalContent input,\n.modalContent select {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin: 5px 0 15px 0;\n}\n\n.modalContent label {\n  display: block;\n  margin-bottom: 5px;\n  color: #555;\n  font-weight: 500;\n}\n\n.networthSection {\n  margin-top: 20px;\n}\n\n.hideNumberSpinner {\n  /* Hide number input spinners for Webkit browsers */\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.hideNumberSpinner::-webkit-inner-spin-button,\n.hideNumberSpinner::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Hide number input spinners for Firefox */\n.hideNumberSpinner[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n@media screen and (max-width: 1024px) {\n  .MainWrapper {\n    width: 95%;\n  }\n\n  .FormContainer {\n    width: 95%;\n  }\n\n  .topText {\n    font-size: 18px;\n  }\n}\n\n@media screen and (max-width: 850px) {\n  .motherNameFields {\n    width: 100%;\n    box-sizing: border-box;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .MainContainer {\n    padding: 15px;\n  }\n\n  .topText {\n    font-size: 16px;\n  }\n\n  .clockText {\n    font-size: 12px;\n  }\n\n  .parentRow {\n    flex-direction: column;\n  }\n\n  .parentField {\n    width: 100%;\n  }\n\n  .motherNameFields {\n    flex-direction: column;\n    gap: 15px;\n    width: 100%;\n    box-sizing: border-box;\n    padding: 0;\n    margin: 10px 0;\n  }\n\n  .motherNameFields input {\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .nomineeDetails {\n    padding: 15px;\n  }\n\n  .rowFields {\n    flex-direction: column;\n    gap: 15px;\n  }\n\n  .dobInputs {\n    justify-content: space-between;\n  }\n\n  .dobInputs input {\n    width: 28%;\n  }\n\n  .networthFields {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .networthFields > input:first-child {\n    width: 100% !important;\n    flex: none;\n  }\n\n  .dateFields {\n    width: 100%;\n    display: flex;\n    gap: 10px;\n  }\n\n  .dateFields input,\n  .dateFields .nomineeDetailsInput {\n    width: auto !important;\n    flex: 1;\n    min-width: 0;\n  }\n\n  .dropdownRow {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 5px;\n  }\n\n  .customDropdown {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .MainContainer {\n    padding: 10px;\n  }\n\n  .MainWrapper {\n    width: 100%;\n    border-radius: 12px;\n  }\n\n  .FormContainer {\n    width: 100%;\n    padding: 10px;\n  }\n\n  .verifyButton {\n    width: 90%;\n    padding: 10px 20px;\n  }\n\n  .nomineeDetailsInput {\n    height: 38px;\n    padding: 8px 12px;\n  }\n}\n\n.dobLabel {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.minorBadge {\n  font-size: 10px;\n  font-weight: 500;\n  padding: 2px 6px;\n  border-radius: 999px;\n  background: #fff4e5;\n  color: #b45309;\n  border: 1px solid #facc15;\n  white-space: nowrap;\n  margin-left: 5px;\n}\n\n.addressLabel {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.addressMeta {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n}\n\n.addressCheckbox {\n  width: 12px;\n  height: 12px;\n  /* cursor: not-allowed; */\n}\n\n.addressCheckboxText {\n  font-size: 11px;\n  color: #475569;\n  white-space: nowrap;\n}\n\n.parentRow {\n  display: flex;\n  gap: 16px;\n}\n\n.parentField {\n  flex: 1;\n}\n\n.parentField input {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"MainContainer": `Profile_MainContainer__JSkc0`,
	"MainWrapper": `Profile_MainWrapper__Cbv2X`,
	"topDiv": `Profile_topDiv__aMsi1`,
	"topText": `Profile_topText__cv3SY`,
	"topClockDiv": `Profile_topClockDiv__RFvm6`,
	"clockIcon": `Profile_clockIcon__XzJ6d`,
	"clockText": `Profile_clockText__isfp1`,
	"PageText": `Profile_PageText__O5+g0`,
	"shieldDiv": `Profile_shieldDiv__9NdUX`,
	"shieldText": `Profile_shieldText__QskPM`,
	"Line": `Profile_Line__x5ynZ`,
	"verifyButton": `Profile_verifyButton__AOYs4`,
	"FormContainer": `Profile_FormContainer__LX6Di`,
	"FormText": `Profile_FormText__8b7ym`,
	"mandatoryAsterisk": `Profile_mandatoryAsterisk__5OfYd`,
	"errorText": `Profile_errorText__AYOYa`,
	"inputLabelGroup": `Profile_inputLabelGroup__exFuW`,
	"hasError": `Profile_hasError__-adn2`,
	"inputError": `Profile_inputError__5x0Sn`,
	"nomineeSection": `Profile_nomineeSection__vtMkL`,
	"nomineeHeader": `Profile_nomineeHeader__NS5NL`,
	"nomineeCard": `Profile_nomineeCard__c3rjw`,
	"nomineeCardHeader": `Profile_nomineeCardHeader__f0hwe`,
	"nomineeCardBody": `Profile_nomineeCardBody__jpchL`,
	"nomineeRow": `Profile_nomineeRow__Hq85e`,
	"nomineeField": `Profile_nomineeField__gdulK`,
	"nomineeInput": `Profile_nomineeInput__fzQWq`,
	"nomineeSelect": `Profile_nomineeSelect__0ScyW`,
	"dobGroup": `Profile_dobGroup__C+9CE`,
	"dobInput": `Profile_dobInput__U93fJ`,
	"shareField": `Profile_shareField__24d4t`,
	"shareSlider": `Profile_shareSlider__c4+W-`,
	"shareValue": `Profile_shareValue__kbhC3`,
	"guardianSection": `Profile_guardianSection__DURrt`,
	"slideDown": `Profile_slideDown__T63DL`,
	"guardianSectionTitle": `Profile_guardianSectionTitle__AkQy8`,
	"nomineeTabs": `Profile_nomineeTabs__ivFdj`,
	"nomineeTab": `Profile_nomineeTab__IMnrs`,
	"active": `Profile_active__2PlmE`,
	"nomineeTabContent": `Profile_nomineeTabContent__qUIP4`,
	"fadeIn": `Profile_fadeIn__hipNC`,
	"customDropdown": `Profile_customDropdown__FB-31`,
	"mandatorySection": `Profile_mandatorySection__2NPK2`,
	"MandatoryHeading": `Profile_MandatoryHeading__kJrKR`,
	"mandatoryCard": `Profile_mandatoryCard__ewU1P`,
	"MandatoryContainer": `Profile_MandatoryContainer__4BBZ9`,
	"MandatoryText": `Profile_MandatoryText__b8TvX`,
	"MandatoryTick": `Profile_MandatoryTick__+LvUh`,
	"nomineeCount": `Profile_nomineeCount__5GF-n`,
	"nomineeDetails": `Profile_nomineeDetails__+zHbn`,
	"guardianDetails": `Profile_guardianDetails__UJo9W`,
	"rowFields": `Profile_rowFields__YTTVl`,
	"fieldColumn": `Profile_fieldColumn__tOYob`,
	"shareContainer": `Profile_shareContainer__n478q`,
	"sliderContainer": `Profile_sliderContainer__Eb2qX`,
	"slider": `Profile_slider__boyi2`,
	"sliderValue": `Profile_sliderValue__g0pxB`,
	"dobContainer": `Profile_dobContainer__BVeDT`,
	"dobInputs": `Profile_dobInputs__8Tmw7`,
	"nomineeDetailsInput": `Profile_nomineeDetailsInput__IWWop`,
	"networthFields": `Profile_networthFields__6yf4N`,
	"dateFields": `Profile_dateFields__-Soti`,
	"motherNameSection": `Profile_motherNameSection__O48qt`,
	"motherNameFields": `Profile_motherNameFields__hVGBB`,
	"dropdownSection": `Profile_dropdownSection__if3uk`,
	"dropdownRow": `Profile_dropdownRow__Vof0c`,
	"modal": `Profile_modal__sSw3A`,
	"modalHeader": `Profile_modalHeader__BBK-z`,
	"closeButton": `Profile_closeButton__uH0wh`,
	"saveButton": `Profile_saveButton__5-LHJ`,
	"modalContent": `Profile_modalContent__wmjZ1`,
	"networthSection": `Profile_networthSection__HbA0L`,
	"hideNumberSpinner": `Profile_hideNumberSpinner__-NFpw`,
	"parentRow": `Profile_parentRow__Hg3Kf`,
	"parentField": `Profile_parentField__bQRTN`,
	"dobLabel": `Profile_dobLabel__xLGti`,
	"minorBadge": `Profile_minorBadge__vr25m`,
	"addressLabel": `Profile_addressLabel__Ezxb8`,
	"addressMeta": `Profile_addressMeta__8PQd1`,
	"addressCheckbox": `Profile_addressCheckbox__5aCDX`,
	"addressCheckboxText": `Profile_addressCheckboxText__K0ARR`
};
export default ___CSS_LOADER_EXPORT___;
